import React from "react";
import "./recipes.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Index from "./pages/index";
import RecipeView from "./pages/recipes/view";
import RecipeNew from "./pages/recipes/new";
import RecipeEdit from "./pages/recipes/edit";
import { StoreProvider } from "./contexts/store-context";

// import startMirage from "./mirage/start";
//
// startMirage();

let currentVersion = process.env.REACT_APP_COMMIT_REF;

if (process.env.NODE_ENV === "production") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      fetch(`/index.html?_=${Date.now()}`)
        .then(res => res.text())
        .then(htmlString => {
          let doc = new DOMParser().parseFromString(htmlString, "text/html");
          let latestVersion = doc
            .querySelector("meta[name='app-version']")
            .getAttribute("content");

          if (latestVersion !== currentVersion) {
            window.location.reload(true);
          }
        });
    }
  });
}

export default function App() {
  return (
    <StoreProvider>
      <div className="max-w-7xl mx-auto">
        <div className="p-6">
          <Router>
            <Switch>
              <Route path="/" exact component={Index} />
              <Route path="/recipes/new" exact component={RecipeNew} />
              <Route path="/recipes/:id/edit" component={RecipeEdit} />
              <Route path="/recipes/:id" component={RecipeView} />
            </Switch>
          </Router>
        </div>
      </div>
    </StoreProvider>
  );
}
